/* ProminentSection.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _27 = "@media (min-width:64rem) and (max-width:89.99rem){._1acz1gtx{padding:var(--_1bm102r)}}";
const _26 = "@media (min-width:48rem) and (max-width:63.99rem){._13zn1gtx{padding:var(--_1bm102r)}}";
const _25 = "@media not all and (min-width:48rem){._15txwcbu{padding:var(--_4thsry)}}";
const _24 = "._1wpz1fhb{align-self:stretch}";
const _23 = "._2lx21bp4{flex-direction:column}";
const _22 = "._1e0c1txw{display:flex}";
const _21 = "._zulpxy5q{gap:var(--ds-space-400,2pc)}";
const _20 = "._1yt4ojjz{padding:var(--_8gy4v2)}";
const _19 = "@media (min-width:64rem){._glte1n77{width:42.5rem}._165tgmlh{height:37.5rem}._1sbq14ah{top:-3.75rem}._bjm478gw{left:-3rem}}";
const _18 = "@media (min-width:48rem) and (max-width:63.99rem){._12rruc05{width:33.75rem}._1vkhbejm{height:31.25rem}._1zty14ah{top:-3.75rem}._1cj1c7mi{left:var(--ds-space-negative-250,-20px)}}";
const _17 = "@media (min-width:30rem) and (max-width:47.99rem){._7bccwgww{width:106%}._1eal1uhs{top:-4.25rem}._1g1oc7mi{left:var(--ds-space-negative-250,-20px)}}";
const _16 = "@media (min-width:0rem) and (max-width:29.99rem){._ho2t1380{width:105%}._1sai1ccs{height:35rem}._1db2s2bg{top:-8rem}._13t4c7mi{left:var(--ds-space-negative-250,-20px)}}";
const _15 = "._1pby1mrw{z-index:-1}";
const _14 = "._t9ec13hc{transform:rotate(-2deg)}";
const _13 = "._kqswstnw{position:absolute}";
const _12 = "._1g0v1mrw:before{z-index:-1}";
const _11 = "._1rusp7j4:before{background-color:var(--ds-background-accent-purple-subtlest,#f3f0ff)}";
const _10 = "._qnecxmi2:before{left:var(--ds-space-negative-150,-9pt)}";
const _9 = "._1aukxmi2:before{top:var(--ds-space-negative-150,-9pt)}";
const _8 = "._kfgt1vuk:before{height:90%}";
const _7 = "._1mp4fknx:before{width:calc(100% + 24px)}";
const _6 = "._1cs8stnw:before{position:absolute}";
const _5 = "._1kt9b3bt:before{content:\"\"}";
const _4 = "@media (min-width:64rem){._dryrzwfg:before{border-radius:2pc}._1jqu1ssb:before{width:50%}._mszq1n8h:before{height:70%}}";
const _3 = "@media (min-width:48rem){._1dmf1tcg:before{border-radius:24px}._479210v4:before{top:var(--ds-space-negative-300,-24px)}._ujk910v4:before{left:var(--ds-space-negative-300,-24px)}._4h6x13sl:before{width:85%}._wz931nrf:before{height:60%}._3uq51gwv:before{min-height:360px}}";
const _2 = "._rfx37vkz:before{border-radius:1pc}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { media } from '@atlaskit/primitives/responsive';
import { useStatsig } from '@atlassian/mpac-feature-flags';
import React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _ = "._kqswh2mm{position:relative}";
const ProminentSectionWrapper = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_kqswh2mm", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ProminentSectionWrapper.displayName = 'ProminentSectionWrapper';
}
const ProminentSectionWrapperStyle = null;
const ProminentSectionBackground = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_rfx37vkz _1dmf1tcg _479210v4 _ujk910v4 _4h6x13sl _wz931nrf _3uq51gwv _dryrzwfg _1jqu1ssb _mszq1n8h _1kt9b3bt _1cs8stnw _1mp4fknx _kfgt1vuk _1aukxmi2 _qnecxmi2 _1rusp7j4 _1g0v1mrw", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ProminentSectionBackground.displayName = 'ProminentSectionBackground';
}
const ProminentSectionBackgroundStyle = null;
const ProminentSectionBackgroundWC = () => {
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_13, _14, _15, _16, _17, _18, _19]
    }), /*#__PURE__*/_jsx("div", {
      className: ax(["_kqswstnw _t9ec13hc _1pby1mrw _ho2t1380 _1sai1ccs _1db2s2bg _13t4c7mi _7bccwgww _1eal1uhs _1g1oc7mi _12rruc05 _1vkhbejm _1zty14ah _1cj1c7mi _glte1n77 _165tgmlh _1sbq14ah _bjm478gw"]),
      children: /*#__PURE__*/_jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        viewBox: "0 0 767 654",
        style: {
          fill: "var(--ds-background-accent-purple-subtlest, #F3F0FF)"
        },
        children: /*#__PURE__*/_jsx("path", {
          d: "M0.101791 170.721C0.101791 170.721 196.617 138.197 319.722 105.395C445.737 71.8168 636.647 0.159094 636.647 0.159094C636.647 0.159094 656.665 149.786 681.397 242.988C706.901 339.097 766.056 483.122 766.056 483.122C766.056 483.122 569.541 515.646 446.437 548.448C320.422 582.026 129.511 653.684 129.511 653.684C129.511 653.684 49.63 508.099 24.8974 414.897C-0.606674 318.788 0.101791 170.721 0.101791 170.721Z"
        })
      })
    })]
  });
};
export const ProminentSection = _ref3 => {
  let {
    children
  } = _ref3;
  const {
    enableMpacWebCoherence
  } = useStatsig();
  if (enableMpacWebCoherence()) {
    return /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_20, _21, _, _22, _23, _24, _25, _26, _27]
      }), /*#__PURE__*/_jsxs("div", {
        className: ax(["_1yt4ojjz _zulpxy5q _kqswh2mm _1e0c1txw _2lx21bp4 _1wpz1fhb _15txwcbu _13zn1gtx _1acz1gtx"]),
        style: {
          "--_8gy4v2": ix("var(--ds-space-800, 64px)".concat(" 0")),
          "--_1bm102r": ix("var(--ds-space-500, 40px)".concat(" 0")),
          "--_4thsry": ix("var(--ds-space-300, 24px)".concat(" 0"))
        },
        children: [/*#__PURE__*/_jsx(ProminentSectionBackgroundWC, {}), children]
      })]
    });
  }
  return /*#__PURE__*/_jsx(ProminentSectionWrapper, {
    children: /*#__PURE__*/_jsx(ProminentSectionBackground, {
      children: children
    })
  });
};